const addressEdit = {
  state: {
    returnAddressId: null,
  },

  mutations: {
    SET_ADDRESS_RETURN(state, payload) {
      state.returnAddressId = payload;
    },
  },

  actions: {},
};

export default addressEdit;
